export default {
    intro: '根据声母提示和释义来推理词汇吧！',
    meaning: '释义',
    example: '例句',
    table: {
        question: '词汇',
        emptyMessage: '没有内容。',
        answerRate: '正确率',
    },
    student: {
        selectionGuide: '看了这些提示，你能猜出是什么词汇吗？',
        know: '我知道！',
        dontKnow: '不知道',
        submit: '提交',
        next: '下一题',
        inputGuide: '请输入你想到的词汇！',
        inputPlaceholder: '请输入答案',
        meaningN: '释义 {n}',
        imageN: '图片 {n}',
        videoN: '视频 {n}',
        additionalMaterials: '附加资料',
    },
    result: {
        myAnswer: '我的答案：',
        know: '知道',
        dontKnow: '不知道',
        dontKnowBracket: '（不知道）',
    },
    stats: {
        mostIncorrect: '错误最多的词汇',
        vocabulary: '词汇',
        meaning: '释义',
        accuracy: '正确率',
        moreN: '等{n}个',
    },
    reactions: {
        knowSelect: [
            '哦！你很有自信呢！',
            '好的！我们来看看吧！',
            '不错！看看你答对了没有！',
            '厉害！会是什么词汇呢？',
            '很好！一起来看答案吧！',
        ],
        correct: [
            '答对了！真棒！',
            '哇！你完全知道呢！',
            '正确！太厉害了！',
            '太棒了！完全正确！',
            '做得好！真了不起！',
        ],
        dontKnowSelect: ['没关系！我们一起来看看吧！', '别担心！看看例句就知道了！', '没问题！一起看提示吧！'],
        maxAttempts: '没关系。我们一起来看看这是什么词汇吧！',
        maxAttemptsNext: '看看是什么词汇，然后进入下一个吧！',
    },
    teacher: {
        modal: {
            clearConfirm: {
                title: '清空所有待添加的词汇？',
                message: '所有待添加的词汇将被删除。继续吗？',
            },
            closeConfirm: {
                title: '丢弃已输入的内容吗？',
                message: '关闭后待添加列表的词汇会全部消失。继续吗？',
            },
            questionDelete: {
                title: '删除此题目？',
                // {word}: 被删除题目的词条。提示将从活动中永久移除。
                message: "题目 '{word}' 将从活动中删除。继续吗？",
            },
            waitItemDelete: {
                title: '删除待添加词汇？',
                // {word}: 被删除的待添加词汇。仅从队列中移除，不影响活动。
                message: "将 '{word}' 从待添加列表中删除。继续吗？",
            },
            // {count}: 因词典重复而跳过的词汇数
            duplicateNotice: '已注册的 {count} 个词汇未被添加。',
            // {count}: 因无释义而跳过的词汇数
            skippedNotice: '{count} 个无释义的词汇未被添加。',
            // 混合(无释义+有释义)登录时确认弹窗
            mixedEmptyConfirm: {
                title: '要注册吗？',
                line1: '{empty} 个无释义的词汇将不会被添加。',
                line2: '仅注册剩余的 {valid} 个词汇？',
            },
            // 仅剩无释义词汇时的提示
            onlyEmptyNotice: {
                title: '无法注册',
                message: '没有可注册的词汇。只剩下无释义的词汇。',
            },
            registerFailed: '添加失败。',
        },
    },
};
